<template>
  <div class="games">
    <div class="container page_banner game_banner ">
      <div class='page_width'>
       <div class="banner_gruop" v-animate="'animate__animated animate__slideInDown'">
          <div class="banner_title">About Us</div>
          <!-- <div class="banner_tips">We pride ourselves on our ability to blend cutting-edge technology with imaginative design, resulting in games that are both visually stunning and incredibly fun to play.</div> -->
       </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_thumb ">
        <div class="page_container cate_container"> 
          <div class="group_bg flex_sb">
            <div class="group_1"></div>
            <div class="group_2"></div>
          </div>
            <div class="page_width" >
              <div class="grid grid_xs_gap ">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                  <div class="item_img" v-animate="'animate__animated animate__rotateIn'">
                    <img src="../../assets/image/tu5.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_center">
                  <div class="item_group">
                    <div class="item_inner">
                        <div class="group_half ">        
                          <div class="half_container" v-animate="'animate__animated animate__rotateInDownLeft'">
                            <div class="half_tag">INDIE GAMES - CRAFTING EXCELLENCE</div>
                            <div class="half_title">Established in 2021 Uniting Visionaries <span class="color3"> & Creators</span></div>   
                            <div class="half_text">Fueled by passion and innovation,FUTURE LASER is dedicated to evolving our platform, delivering cutting-edge indie games that captivate players worldwide.</div>
                            <div class="half_flag">Exceptional Community Engagement</div>
                            <div class="half_flag">Premium Indie Game Development</div>
                            <div class="bg_btn pointer color2">
                              <span class="">GET IN TOUCH</span>
                               <i class="arrow el-icon-caret-right"></i>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="container " style="padding-bottom:80px"> 
      <div class="page_width page_top ">
        <div class="page_title" v-animate="'animate__animated animate__lightSpeedInLeft'">
          <div class="title_name">Our Expertise</div>
          <!-- <div class="title_info">Our team is a dynamic blend of creative minds and tech innovators united by a passion for gaming. From visionary designers to skilled coders, we collaborate to craft immersive worlds that captivate players worldwide. With a focus on innovation and storytel</div> -->
        </div>
        <div class="page_thumb pl_thumb">
          <div class="page_container"> 
            <div class="grid grid_md_gap grid_gap_none ">
                 <div class="grid_md_12 grid_xs_12 grid_sm_12 " v-for="(item,index) in joinList" :key="index">
                    <div class="pl_group ">
                      <div class="pl_inner">
                        <div class="pl_grid flex_sb" :class="[item.id==2||item.id==4?'flex_reve':'']">
                          <div class="group_img">
                            <img :src="item.img" alt="">
                          </div>
                          <div class="pl_box" >
                             
                            <div class="box_title">{{ item.title }}</div>
                            <div class="star_group "> {{ item.year }}</div>
                            <div class="box_msg" >{{ item.msg1 }}</div>
                           
                            
                          </div>
                        </div>
                      </div>
                    </div>
                 </div>
               </div>
          </div>
        
        </div>
        
      </div>
    </div>


     <!-- <div class="container"> 
      <div class="page_thumb page_top" >
        <div class="page_container cate_container" style="background: #1C3725;"> 
          
            <div class="page_width" >
              <div class="grid grid_xs_gap ">
                
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_col_center">
                  <div class="item_group">
                    <div class="item_inner">
                        <div class="group_half ">        
                          <div class="half_container" v-animate="'animate__animated animate__rotateInDownLeft'">
                            <div class="half_title">Frequently Asked Questions</div>
                            <el-collapse v-model="activeName" accordion>
                              <el-collapse-item title="Are your games free to play?" name="1">
                                <div>Some of our games are free-to-play with optional in-game purchases, while others are premium titles. Check the game’s store page for details.</div>
                                
                              </el-collapse-item>
                              <el-collapse-item title="How do I report issues or bugs?" name="2">
                                <div></div>
                                
                              </el-collapse-item>
                              <el-collapse-item title="How can I get in touch with FUTURE LASER?" name="3">
                                <div></div>
                            
                              </el-collapse-item>
                              
                            </el-collapse>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="grid_md_5 grid_xs_12 grid_sm_12">
                  <div class="item_img" v-animate="'animate__animated animate__rotateIn'">
                    <img src="../../assets/image/tu10.png" alt="">
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div> -->
  </div>

</template>

<script>
import { swiper, swiperSlide,} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
    
  },
  data () {
    return {
      tabId:'',
      screenWidth: document.body.clientWidth,
      activeName:1
     
    }
  },
  created () {

  },
  methods: {

    toPage(path){ 
      this.$router.push(path)
    },
    
    
  },
  mounted () {
  
    
  },
  computed:{
    joinList(){return this.$store.state.joinList}
    
  },
  watch: {

    
  },
  beforeDestroy() {
  
  },


  
}
</script>
<style lang='scss' scoped>
.games {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color:#fff;
  margin-top:-80px;

  .page_top{
    margin-top:80px;
  }
 
  .item_group{
   height: 100%;
   width: 100%;
 
    .item_inner{
        position: relative;
        
      }
  .group_half{
    padding:0 20px;
    .min_title{
        color:$theme_color3;
        font-size:40px;
        margin-bottom:20px;
        text-align: left;
      }
    .half_container{
      
      text-align: left;
   
      @media screen and (max-width : 767px){
        .half_title{
          font-size:24px!important;
          
        }
        .half_msg{
          font-size: 16px!important;
        }
        /deep/ .el-collapse-item__header{
            font-size: 18px!important;
            padding:10px 0 !important;
          }
      }
      .half_title{
          font-size: 40px;
          color:$theme_color4;
          padding:30px 0;
        }
        .half_msg{
          font-size: 18px;
          color:$theme_color4;
          font-family: PingFang SC, PingFang SC;;
        }
        .half_text{
          font-size: 18px;
          color:$theme_color4;
          font-family: PingFang SC, PingFang SC;
          padding-bottom:30px;
          line-height: 1.8;
        }
        .half_tag{
          font-size: 14px;
          color:$theme_color3;
          text-decoration-line: underline;
        }
        .half_flag{
          padding-left:20px;
          position: relative;
          margin-top:20px;
          &::before{
            content:'';
            height: 100%;
            width:1px;
            background:$theme_color3;
            position:absolute;
            left:0;
          }
         
        }
        .bg_btn{
          display: inline-block;
          margin-top:50px;
          padding:10px;
        }
      .el-collapse{
        background:transparent;
        border:none;
      }
     /deep/ .el-collapse-item__header{
        color:#fff;
        background:transparent;
        font-size: 30px;
        padding:20px 0;
        height: auto;
      }
      /deep/.el-collapse-item .is-active{
        color:#14DF86;
      }
      /deep/.el-collapse-item__wrap{

      
        background:transparent;
      }
      /deep/.el-collapse-item__content{
          color:#fff;
      }
    }
    
   
    
    
  }
   
    
  }
 .pl_thumb{
  position: relative;
  &::after{
    content:'';
   
    width:1px;
    background:#14DF86;
    left:50%;
    top:20px;
    bottom:20px;
    position: absolute;
  }
 }
 .pl_group{
      position: relative;
      .flex_reve{
        flex-direction: row-reverse;
        text-align: right!important;
      }
      .pl_inner{
        .pl_grid{
          position: relative;
          padding:20px 0;
          text-align: left;
          .group_img{
            width: 45%;
            
          }
          
          .pl_box{
            
            width: 45%;
            @media screen and (max-width : 767px){
              .box_msg{
                 font-size: 12px;
                 line-height: 20px!important;
              }
             .star_group{
              padding:0!important;
              font-size: 40px!important;
             }
             .box_msg{
              padding-top:10px!important;
             }
            }
           .box_msg{
            font-family: PingFang SC, PingFang SC;
            font-weight: 300;
            line-height: 30px;
            padding-top:30px;
           }
           .box_title{
            font-size: 20px;
            // padding:10px 0;
            color:#14DF86;
           }
          .star_group{
            padding:20px 0;
            border-bottom:1px solid #849188;
            font-size: 60px;
          }

          }
        }
      }

    }
  
  .cate_container{
      padding:50px 0 20px; 
      position: relative;
      .group_bg{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 0;
      }
      .group_1{
        background-image:url(../../../public/bg/fk_1.png);
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        width: 40%;
        height: 80%;
        align-self: start;
      }
      .group_2{
        background-image:url(../../../public/bg/fk_2.png);
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        width: 40%;
        height: 80%;
        align-self: end;
      }
  }

  
 
 

 
}

</style>
<style lang="scss">

.swiper-pagination-bullet-active{
  background: $theme_color3 !important;
  width: 80px!important;
}
.my-bullet-active{
  background: $theme_color3 !important;
  width: 80px!important;
 
  }
</style>